$shm_hitalama_skills_drag $shm_hitalama_dragtree
	catalog $shm_hitalama_skills_catalog
	locked false
	reversed false
	drag_hold_delay 300
	drag_touch_action \auto
	drop_root_gutter true
